import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@agencypmg/alli';

export default function SelectedClient({ onClick, clientName, children }) {
    return (
        <>
            <div
                className="flex items-baseline align-baseline text-black font-medium text-sm"
                aria-label="Current Client"
            >
                <span>{clientName}</span>

                <Button
                    size="sm"
                    variant="link"
                    className="hidden md:inline-block text-xs font-medium"
                    aria-label="click to change client"
                    onClick={onClick}
                >
                    Change
                </Button>
            </div>
            {children}
        </>
    );
}
